// ThreadList
import ClassNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import { ScrollContainer } from 'scrollmonitor-react';
import { connect } from 'react-redux'

import Filters from './Filters';
import InsiderNotificationForm from './InsiderNotificationForm';
import MessageList from './MessageList';
import ThreadForm from './ThreadForm';
import ThreadListItem from './ThreadListItem';
import {
  select as threadSelect,
  toggleQuestionToolbox
} from '../redux/actions/threadsAction';


@connect((Store) => {
  return {
    selectedThread: Store.threads.selectedThread
  };
})

export default ScrollContainer(class ThreadList extends React.Component {
  handleThreadClick(threadId) {
    if (
      !this.props.selectedThread
      || threadId !== this.props.selectedThread.id
    ) {
      this.props.dispatch(threadSelect(threadId));
    } else {
      this.props.mobilePanelChange('messages');
    }
  }

  handleClickToggleToolbox(threadId) {
    this.props.dispatch(toggleQuestionToolbox(threadId));
  }

  render () {
    return (
      <div className="threads-list" id="threadList" ref={this.props.listRef}>
        {
          _.map(_.orderBy(this.props.threads, [ this.props.sortKey ], this.props.sortOrder), (thread, i) => {
            return (
              <ThreadListItem
                scrollContainer={this.props.scrollContainer}
                key={'q' + i}
                thread={thread}
                isSelected={(this.props.selectedThread && this.props.selectedThread.id === thread.id)}
                handleClick={this.handleThreadClick.bind(this)}
                addScrollBannerTarget={this.props.addScrollBannerTarget}
                removeScrollBannerTarget={this.props.removeScrollBannerTarget}
                handleToggleToolbox={this.handleClickToggleToolbox.bind(this)}
              />
            );
          })
        }
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/ThreadList.jsx